import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import i18n from 'locales/i18n';
import { ITrackFilteredListParams } from 'services/tracks/types';

import { STATUS } from 'services/types';
import { booleanLabel } from 'utils/components/inputs/booleanLabel';

registerQueryFilterLabels<ITrackFilteredListParams>(
  'track',
  {
    status: ({ value }) =>
      value !== undefined ? i18n.t(`enum.STATUS.${STATUS[value as STATUS]}`) : null,

    hasDuplicatedArtist: booleanLabel('input.label.hasDuplicatedArtist'),
    hasContracts: booleanLabel('input.label.hasContracts'),
  },
  {
    hasContracts: ({ key, setValues }) => {
      setValues((prev) => ({ ...prev, [key]: undefined as any }));
    },
    hasDuplicatedArtist: ({ key, setValues }) => {
      setValues((prev) => ({ ...prev, [key]: undefined as any }));
    },
  },
);
